import {FC, PropsWithChildren, ReactNode} from "react";

interface Props {
  title: ReactNode;
  /** Rendered inside the footer bar. Wrap in a flex div if needed. */
  footer?: ReactNode;
  /** Allow main body to scroll (use for tall forms). */
  scrollable?: boolean;
}

/**
 * Standard modal inner layout: white card, brand border, divided header / body / footer.
 * Wrap this inside <Modal open={...} close={...}>.
 */
const ModalLayout: FC<PropsWithChildren<Props>> = ({title, footer, children, scrollable}) => (
  <div className="bg-white rounded-2xl border border-brand-border divide-y divide-brand-border w-full max-w-md">
    <div className="px-5 py-4">
      <h2 className="text-lg font-bold text-brand-navy">{title}</h2>
    </div>
    <div className={["flex flex-col px-5 py-4 gap-4", scrollable && "overflow-y-auto max-h-[60vh]"].asClass}>
      {children}
    </div>
    {footer && <div className="flex items-center justify-between gap-3 px-5 py-4">{footer}</div>}
  </div>
);

export default ModalLayout;
